import PageComponent from '../base/PageComponent';

export default class FooterModule extends PageComponent
{
    init() {
        this.bindButton();
        this.addEvent('form', 'submit', e => this.ajaxSubmit(e));
    }

    bindButton() {
        this.addEvent('.footer__scroll', 'click', e => this.onButtonClick(e));
    }

    onButtonClick(e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: 0
        }, 500);
    }

    ajaxSubmit(e){
        e.preventDefault();
        let url = e.target.getAttribute('action'),
            formData = new FormData(e.target),
            headers = new Headers(),
            self = this;

        headers.append("X-Requested-With", "XMLHttpRequest");

        fetch(url, {
            method: 'POST',
            headers: headers,
            body: formData
        }).then(response => {
            return response.json();
        }).then(json => {
            let status = json.Status;
            if(status == 1){
                e.target.style.display = 'none';
                self.childElements('.success')[0].style.display = 'block';
            }
        });
    }
}


// WEBPACK FOOTER //
// ./javascript/modules/FooterModule.js